// Subject- and type-specific colours for Scimos.
//
// The four Learn subject colours are sampled directly from the subject icons on
// the homepage (the coloured ring behind each icon). Health and Tech only appear
// under News and have no homepage icon, so they use palette-consistent
// placeholders — swap these for the real icon colours once available.

export const subjectColours = {
    biology: "#664da6", // purple
    chemistry: "#25a69a", // teal
    physics: "#3c84c5", // blue
    maths: "#c27ba0", // pink
    health: "#d46a6a", // placeholder — coral
    tech: "#6b6ecf", // placeholder — indigo
} as const;

export type Subject = keyof typeof subjectColours;

// Section ("Learn" / "News") accent colours.
export const typeColours = {
    learn: "#0097a7",
    news: "#67c1b8",
} as const;

export type SectionType = keyof typeof typeColours;

// Subjects shown under each section, in display order.
export const learnSubjects: Subject[] = ["biology", "physics", "chemistry", "maths"];
export const newsSubjects: Subject[] = ["biology", "physics", "chemistry", "maths", "health", "tech"];

export const subjectsForType = (type: SectionType): Subject[] => (type === "learn" ? learnSubjects : newsSubjects);
